import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Progress } from 'antd';
import { selectedSection$ } from "../../reduxStore/selectors/questionSelectors";
import sectionType from "../../utils/Enum/sectionType";
import styles from "./asset/examinationHeader.module.scss";

const ExaminationHeader = ({
    isExamination = false,
    onPracticeMenuClick
}) => {
    const selectedSection = useSelector(selectedSection$);
    const [timeElapsed, setTimeElapsed] = useState(0); // in seconds
    const totalTime = 134 * 60; // 2:14 = 134 minutes = 8040 seconds

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeElapsed(prev => {
                if (prev >= totalTime) {
                    clearInterval(timer);
                    // Handle exam timeout here
                    return totalTime;
                }
                return prev + 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [totalTime]);

    const formatTime = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);

        if (hours > 0) {
            return `${hours}:${minutes.toString().padStart(2, '0')}`;
        }
        return `${minutes} min`;
    };

    const formatMinutes = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        return `${minutes} min`;
    };

    const remainingTime = totalTime - timeElapsed;
    const progressPercentage = (timeElapsed / totalTime) * 100;
    const isPracticeAllModule = selectedSection === sectionType.PRACTICE_ALL_READING_WRITING || selectedSection === sectionType.PRACTICE_ALL_MATH;

    return (
        <>
            <div className={styles.frameParent}>
                <div className={styles.satPracticeParent}>
                    <div className={styles.satPractice}>{isExamination ? "SAT Exam" : `${selectedSection || sectionType.INFORMATION_AND_IDEAS}`}</div>
                    <div className={styles.readingWritting}>{isPracticeAllModule ? "Practice Mode - Full Modules" : "Practice Mode - Individual Topic"}</div>
                </div>
                {isExamination ? (
                    <div className={styles.calendarClockParent}>
                        <svg className={styles.calendarClock} width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <label>Time</label>
                        <div className={styles.time245}>{formatTime(remainingTime)}</div>
                    </div>
                ) : (
                    <button
                        className={styles.practiceMenuButton}
                        onClick={onPracticeMenuClick}
                    >
                        <img className={styles.practiceMenuIcon} alt="" src={require("../../publicAsset/media/Menu_Alt.svg").default} />
                        <div className={styles.practiceMenuText}>Menu</div>
                    </button>
                )}
            </div>
            {isExamination && (
                <div className={styles.timeRun}>
                    <Progress
                        percent={progressPercentage}
                        percentPosition={{ align: 'end', type: 'inner' }}
                        format={() => <div className={styles.timeInfoBadge}>
                            <div className={styles.timeInfo}>
                                {formatMinutes(remainingTime)}
                            </div>
                        </div>}
                        strokeColor="#1e0ea4"
                        trailColor="#e5e7eb"
                        strokeWidth={24}
                        className={styles.progressBar}
                    />
                </div>
            )}
        </>
    );
};

export default ExaminationHeader;